import { render, staticRenderFns } from "./MigrationSuccessModal.vue?vue&type=template&id=4e22f15e"
import script from "./MigrationSuccessModal.vue?vue&type=script&lang=ts"
export * from "./MigrationSuccessModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports